import * as React from "react";

import { useSelector } from "react-redux";
import { useStaticContext } from "../../../../core";
import { IState } from "../../../redux";

import { DisplayMobile, IDisplayMobileProps } from "./Display";
import { E2EIdentifier } from "../../../../core/e2e/E2EIdentifier";

export const FreeSpinsDisplayMobile = () => {
  const { language } = useStaticContext();
  const freeSpinsLeft = useSelector((state: IState) => state.freeSpins.value);
  const { FreeSpins: label } = language;

  const value = freeSpinsLeft?.toString() ?? "";

  const dataE2EId = E2EIdentifier.MOBILE_KEYPAD_FREE_SPINS_LEFT;

  const props: IDisplayMobileProps = {
    label: label.toUpperCase(),
    value,
    textAlign: "left",
    dataE2EId
  };

  return <DisplayMobile {...props} />;
};

FreeSpinsDisplayMobile.displayName = "FreeSpinsDisplayMobile";
